<div class="jurisdiction-card">
  <span *ngIf="account.governingJurisdictionId" class="fw-semibold" i18n>{{
    account.governingJurisdictionId | governingJurisdictionName
  }}</span>
  <span *ngIf="!account.governingJurisdictionId" class="fw-semibold" i18n>Non-Locked-In</span>
  <hr class="m-0" />
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column gap-2">
      <div class="fw-semibold">{{ band?.minimumAgeName }}</div>
      <div class="min-age-label" *ngIf="band?.minimumAgeSpouseId" i18n>Spouse</div>
      <div class="min-age-label" *ngIf="!band?.minimumAgeSpouseId" i18n>Member</div>
    </div>
    <div class="d-flex flex-column gap-2">
      <div class="fw-semibold text-end" i18n>Age: {{ band?.minimumAgeDateOfBirth | age : accountYear }}</div>
      <div class="min-age-label" i18n>
        {{ band?.minimumAgeDateOfBirth | date : 'MMMM dd, yyyy' }}
      </div>
    </div>
  </div>
</div>
